'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hasTypicalResponseTimeMessageFromCurrentSession = undefined;

var _isTypicalResponseTimeMessage = require('conversations-schema/pubnub-message/operators/isTypicalResponseTimeMessage');

var _getMessageIsApproximatelyFromCurrentSession = require('conversations-schema/pubnub-message/operators/getMessageIsApproximatelyFromCurrentSession');

var _hasMessages = require('conversations-schema/thread-history/operators/hasMessages');

var _getMessages = require('conversations-schema/thread-history/operators/getMessages');

var hasTypicalResponseTimeMessageFromCurrentSession = exports.hasTypicalResponseTimeMessageFromCurrentSession = function hasTypicalResponseTimeMessageFromCurrentSession(threadHistory) {
  if (!(0, _hasMessages.hasMessages)(threadHistory)) {
    return false;
  }

  var messages = (0, _getMessages.getMessages)(threadHistory);

  var lastTypicalResponseTimeMessage = messages.findLast(_isTypicalResponseTimeMessage.isTypicalResponseTimeMessage);

  return !!(lastTypicalResponseTimeMessage && (0, _getMessageIsApproximatelyFromCurrentSession.getMessageIsApproximatelyFromCurrentSession)(lastTypicalResponseTimeMessage));
};